
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/sampling",
      function () {
        return require("private-next-pages/customer-studio/sampling.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/sampling"])
      });
    }
  